import React, { useMemo } from 'react';
import U2000ComboBoxBase from '../../../formControls/combobox/U2000ComboBoxBase';
import type { U2000CriteriaInitOptionsConfig, U2000CriteriaStaticOption } from '../../basic/U2000BasicTableList';
import { resolveCriteriaInitOptions } from './U2000CriteriaInitOptionsRegistry';

interface U2000CriteriaInitOptionsComboProps {
  config: U2000CriteriaInitOptionsConfig;
  value: string | null;
  onChange: (value: string, displayLabel?: string) => void;
  disabled?: boolean;
}

const U2000CriteriaInitOptionsCombo: React.FC<U2000CriteriaInitOptionsComboProps> = ({
  config,
  value,
  onChange,
  disabled = false,
}) => {
  const options = useMemo(
    () => resolveCriteriaInitOptions(config.optionsKey),
    [config.optionsKey],
  );

  const selected = useMemo(
    () => options.find((o) => o.value === (value ?? '')) ?? (value ? { value, label: value } : null),
    [options, value],
  );

  return (
    <U2000ComboBoxBase<U2000CriteriaStaticOption>
      data={options}
      keyField="value"
      descField="label"
      value={selected}
      onChangeObject={(opt) => onChange(opt?.value ?? '', opt?.label)}
      disabled={disabled}
    />
  );
};

export default U2000CriteriaInitOptionsCombo;
